export default "/_next/static/images/Process_Step_4-18e046c36fad41cf8d3006ecc5270d09.jpg";